import { useState } from 'react';
import { Box, Grid, Typography, Stack, Collapse, Divider, Button } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const PaymentResultPage = () => {
    const [data] = useState(window.serverData || {});
    console.log('data', data);
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                pl: { xs: 2, sm: 4, md: 8, lg: 12 },
                pr: { xs: 2, sm: 4, md: 8, lg: 12 },
                width: '100%',
                borderRadius: 2
            }}
        >
            <Box
                container
                boxShadow={3}
                mt={6}
                mb={8}
                sx={{
                    borderRadius: 2,
                    p: 2,
                    maxWidth: { xs: 400, lg: 500 },
                    background: 'white',
                    overflow: 'hidden',
                    display: 'flex'
                }}
            >
                {data?.status === 'error' ? (
                    <Grid container alignItems="space-between" justifyContent="center">
                        <Grid item xs={12}>
                            <Stack spacing={4} alignItems="center" justifyContent="center" mt={2}>
                                <Box sx={{ display: 'flex', flex: 1, p: 1, background: '#ffe6e6', borderRadius: 50 }}>
                                    <CloseIcon sx={{ fontSize: 70, color: '#ff0000' }} />
                                </Box>
                                <Typography variant="body1" sx={{ fontSize: 24, color: '#ff0000' }}>
                                    {t('PaymentFailed')}
                                </Typography>
                            </Stack>

                            <Stack spacing={3} alignItems="center" justifyContent="center" mb={2} mx={3}>
                                <Divider orientation="horizontal" sx={{ border: '1px solid #000', minWidth: '80%' }} />
                                <Typography variant="body1" sx={{ fontSize: 20, color: '#000' }}>
                                    {t('TransactionDetails')}
                                </Typography>
                                <Grid container spacing={1} alignItems="flex-end" justifyContent="space-between" mt={3}>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#000' }}>
                                            {t('TransactionID')}
                                        </Typography>
                                    </Grid>
                                    <Grid item container xs={4} justifyContent="flex-end">
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#ff0000' }}>
                                            {data?.data.TransUID ?? '-'}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#000' }}>
                                            {t('Date')}
                                        </Typography>
                                    </Grid>
                                    <Grid item container xs={4} justifyContent="flex-end">
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#ff0000' }}>
                                            {data?.data.Date ?? '-'}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#000' }}>
                                            {t('PaymentMethod')}
                                        </Typography>
                                    </Grid>
                                    <Grid item container xs={4} justifyContent="flex-end">
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#ff0000' }}>
                                            {data?.data.PaymentMethod ?? '-'}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#000' }}>
                                            {t('Amount')}
                                        </Typography>
                                    </Grid>
                                    <Grid item container xs={4} justifyContent="flex-end">
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#ff0000' }}>
                                            {data?.data.Amount ?? '-'}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Divider orientation="horizontal" sx={{ border: '1px solid #0085c7', minWidth: '80%' }} />

                                <Typography variant="body1" sx={{ fontSize: 16, color: '#ff0000' }} mb={2}>
                                    {t('ErrorCode')} : {data?.data.ResultCode ?? '-'}
                                </Typography>
                                <Typography variant="subtitle" sx={{ fontSize: 16 }}>
                                    {data?.data.ResultDescription ?? ''}
                                </Typography>
                                {data?.data.ResultCode === '981' && (
                                    <Stack direction="column">
                                        <Typography variant="subtitle" sx={{ fontSize: 16 }} mb={1}>
                                            {t('UnableToExecuteTransaction')}
                                        </Typography>
                                        <Typography variant="subtitle" sx={{ fontSize: 16 }} mb={3}>
                                            {t('PleaseCheckCardDetails')}
                                        </Typography>
                                    </Stack>
                                )}
                                {(data?.data.ResultCode === '1045' || data?.data.ResultCode === '1') && (
                                    <Stack direction="column">
                                        <Typography variant="subtitle" sx={{ fontSize: 16 }}>
                                            {t('UnableToExecuteTransaction')}
                                        </Typography>
                                        <Typography variant="subtitle" sx={{ fontSize: 16 }} mb={1}>
                                            {t('PleaseTryAgain')}
                                        </Typography>
                                    </Stack>
                                )}
                                {data?.data?.RetryLink ? (
                                    <Button variant="outlined" onClick={() => navigate(`/payment/${data?.data?.RetryLink}`)}>
                                        {t('TryAgain')}
                                    </Button>
                                ) : null}
                                {data?.data?.ReturnToDashboard ? (
                                    <Button variant="outlined" onClick={() => navigate(`/home`)}>
                                        {t('MoveToDashboard')}
                                    </Button>
                                ) : null}
                            </Stack>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container alignItems="space-between" justifyContent="center">
                        <Grid item xs={12}>
                            <Stack spacing={4} alignItems="center" justifyContent="center" mt={3}>
                                <Box sx={{ display: 'flex', flex: 1, p: 1, background: '#d5f0c4', borderRadius: 50 }}>
                                    <CheckIcon sx={{ fontSize: 100, color: '#48bd00' }} />
                                </Box>
                                <Typography variant="body1" sx={{ fontSize: 30, color: '#0085c7' }}>
                                    {t('PaymentSuccess')}
                                </Typography>
                            </Stack>

                            <Stack spacing={2} alignItems="center" justifyContent="center" mb={2} mx={3}>
                                <Divider orientation="horizontal" sx={{ border: '1px solid #0085c7', minWidth: '80%' }} />
                                <Typography variant="body1" sx={{ fontSize: 20, color: '#0085c7' }} mb={3}>
                                    {t('TransactionDetails')}
                                </Typography>
                                <Grid container spacing={1} alignItems="flex-end" justifyContent="space-between" mt={3}>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#000' }}>
                                            {t('TransactionID')}
                                        </Typography>
                                    </Grid>
                                    <Grid item container xs={4} justifyContent="flex-end">
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#ff0000' }}>
                                            {data?.data.TransUID ?? '-'}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#000' }}>
                                            {t('Date')}
                                        </Typography>
                                    </Grid>
                                    <Grid item container xs={4} justifyContent="flex-end">
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#0085c7' }}>
                                            {data?.data.Date ?? '-'}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#000' }}>
                                            {t('PaymentMethod')}
                                        </Typography>
                                    </Grid>
                                    <Grid item container xs={4} justifyContent="flex-end">
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#0085c7' }}>
                                            {data?.data.PaymentMethod ?? '-'}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#000' }}>
                                            {t('Amount')}
                                        </Typography>
                                    </Grid>
                                    <Grid item container xs={4} justifyContent="flex-end">
                                        <Typography variant="body1" sx={{ fontSize: 15, color: '#0085c7' }}>
                                            {data?.data.Amount ?? '-'}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Divider orientation="horizontal" sx={{ border: '1px solid #0085c7', minWidth: '80%' }} />
                                {data?.data?.ReturnUrl ? (
                                    <Button variant="outlined" onClick={() => navigate(`/payments/card/${data?.data?.ReturnUrl}`)}>
                                        {t('MoveToCollection')}
                                    </Button>
                                ) : null}
                                {data?.data?.ReturnToDashboard ? (
                                    <Button variant="outlined" onClick={() => navigate(`/home`)}>
                                        {t('MoveToDashboard')}
                                    </Button>
                                ) : null}
                            </Stack>
                        </Grid>
                    </Grid>
                )}
            </Box>
        </Box>
    );
};

export default PaymentResultPage;
